import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=94757a94&scoped=true&"
var script = {}
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=94757a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94757a94",
  null
  
)

export default component.exports